import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { Card } from 'antd';
import { Link } from "react-router-dom";
import HideInfoBoxComponent from '../HideInfoBox/HideInfoBoxComponent';
import getImageState from './../../services/transforImage';
import './style.css';

const RenderBodyCard = ({ setIcon, title, body, link, action }) => {
  return (
    <Fragment>
      <div className="icon">
        <img src={setIcon.src} alt={setIcon.alt} />
      </div>
      <div>
        <h2 onClick={action ? action : () => {}}>{link ? <Link to={link}>{title}</Link> : title}</h2>
        {typeof body === 'object' ? body : <p>{body}</p>}
      </div>
    </Fragment>
  )
}
const InfoBoxComponent = ({ mode, icon, title, body, disabled, action, hoverable, link }) => {
  const setIcon = getImageState(icon);
  return (
    <Fragment>
      {disabled && <HideInfoBoxComponent text={body} />}
      <Card hoverable={hoverable} className={`card-info-box ${mode && mode} ${disabled && 'disabled'}`}>
        <RenderBodyCard setIcon={setIcon} title={title} body={body} link={link} action={action} />
      </Card>
    </Fragment>
  );
}

InfoBoxComponent.propTypes = {
  title: PropTypes.string,
  // The "body" can be a string or object. If it's a string, the DOM representation
  // is like <p>{body}</p>. Otherwise, will be representated in raw {body}
  // Useful if you want to pass another component through body.
  body: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.object,
  ]),
  icon: PropTypes.string,
  mode: PropTypes.string,
  color: PropTypes.string,
  disabled: PropTypes.bool,
  action: PropTypes.func,
  hoverable: PropTypes.bool,
}

InfoBoxComponent.contextTypes = {
  t: PropTypes.func.isRequired,
}

export default InfoBoxComponent;
